export default {
  game: {
    getAllGames: "questions",
    postNewGame: "questions",
    getSingleGame: "questions/{id}",
    postGameAnswer: "questions/{id}",
    postQuestionAnswer: "songs/{id}",
    getSongs: "list/songs",
    getLinks: "list/links",
  }
};
